// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VerifiedInfo-space1-ig6mI {
	margin-bottom: 6px !important;
}

.VerifiedInfo-space2-i7Nri {
	margin-bottom: 12px !important;
}

.VerifiedInfo-space3-XYHnO {
	margin-bottom: 18px !important;
}

.VerifiedInfo-space4-gGb9r {
	margin-bottom: 24px !important;
}

.VerifiedInfo-space5-Fi_kd {
	margin-bottom: 30px !important;
}

.VerifiedInfo-space6-X8Zts {
	margin-bottom: 36px !important;
}

.VerifiedInfo-space7-yD4NC {
	margin-bottom: 42px !important;
}

.VerifiedInfo-spaceTop8-qTxCF {
	margin-bottom: 48px !important;
}

.VerifiedInfo-spaceTop1-v7fIh {
	margin-top: 6px !important;
}

.VerifiedInfo-spaceTop2-_qaVf {
	margin-top: 12px !important;
}

.VerifiedInfo-spaceTop3-ZbVmK {
	margin-top: 18px !important;
}

.VerifiedInfo-spaceTop4-QagfS {
	margin-top: 24px !important;
}

.VerifiedInfo-spaceTop5-KdkL7 {
	margin-top: 30px !important;
}

.VerifiedInfo-spaceTop6-etvUJ {
	margin-top: 36px !important;
}

.VerifiedInfo-spaceTop7-hWZ48 {
	margin-top: 42px !important;
}

.VerifiedInfo-spaceTop8-qTxCF {
	margin-top: 48px !important;
}

.VerifiedInfo-noMargin-AbSkJ {
	margin: 0px !important;
}

.VerifiedInfo-padding1-W5tEV {
	padding-bottom: 6px !important;
}

.VerifiedInfo-padding2-NpPgo {
	padding-bottom: 12px !important;
}

.VerifiedInfo-padding3-TyqIM {
	padding-bottom: 18px !important;
}

.VerifiedInfo-padding4-yHmBf {
	padding-bottom: 24px !important;
}

.VerifiedInfo-padding5-FM1Js {
	padding-bottom: 30px !important;
}

.VerifiedInfo-padding6-xQJOt {
	padding-bottom: 36px !important;
}

.VerifiedInfo-padding7-OBujS {
	padding-bottom: 42px !important;
}

.VerifiedInfo-paddingTop1-ox6fO {
	padding-top: 6px !important;
}

.VerifiedInfo-paddingTop2-rj78r {
	padding-top: 12px !important;
}

.VerifiedInfo-paddingTop3-LlDO1 {
	padding-top: 18px !important;
}

.VerifiedInfo-paddingTop4-OlErE {
	padding-top: 24px !important;
}

.VerifiedInfo-paddingTop5-eJnMJ {
	padding-top: 30px !important;
}

.VerifiedInfo-paddingTop6-u2tVv {
	padding-top: 36px !important;
}

.VerifiedInfo-paddingTop7-TzxrY {
	padding-top: 42px !important;
}

.VerifiedInfo-noPadding-Rari6 {
	padding: 0px !important;
}

.VerifiedInfo-textBold-hjETe {
	font-weight: 500 !important;
}

.VerifiedInfo-textBolder-qVTAb {
	font-weight: 700 !important;
}

.VerifiedInfo-textNormal-Dz64R {
	font-weight: normal !important;
}

.VerifiedInfo-spaceBottom20-bWbH6 {
	margin-bottom: 20px;
}

.VerifiedInfo-spaceBottom10-OaiSH {
	margin-bottom: 10px;
}

.VerifiedInfo-marginNone-_aWDP {
	margin: 0;
}

.VerifiedInfo-spaceBottom15-PRpwb {
	margin-bottom: 15px;
}

.VerifiedInfo-marginTopNone-JjfK0 {
	margin-top: 0;
}

.VerifiedInfo-spaceTop11-mIkav {
	margin-top: 11px;
}

.VerifiedInfo-spaceTop21-spQ3P {
	margin-top: 21px;
}

.VerifiedInfo-spaceTop20-YsY_M {
	margin-top: 20px;
}

.VerifiedInfo-spaceTop10-Ac8wk {
	margin-top: 10px;
}

/*New Design Text Colors */

.VerifiedInfo-textDarkBlue-C1Zh4 {
	color: rgb(20, 39, 94) !important;
}

.VerifiedInfo-textLightBlue-cch8y {
	color: rgb(57, 87, 106) !important;
}

.VerifiedInfo-textLightSandleGreen-s52N2 {
	color: rgb(76, 86, 41) !important;
}

.VerifiedInfo-textLightBrown-kk1Fh {
	color: rgb(115, 79, 33) !important;
}

.VerifiedInfo-textMediumMaroon-WMhwR {
	color: rgb(87, 37, 51) !important;
}

.VerifiedInfo-textBrown-XgeBC {
	color: rgb(160, 47, 24) !important;
}

.VerifiedInfo-textMaroon-wdJB4 {
	color: rgb(155, 49, 67) !important;
}

.VerifiedInfo-textDarkBrown-PPTK7 {
	color: rgb(83, 18, 16) !important;
}

.VerifiedInfo-textMediumBrown-srJzC {
	color: rgb(142, 28, 10) !important;
}

.VerifiedInfo-textSkyBlue-Ai_5V {
	color: rgb(37, 117, 141) !important;
}

.VerifiedInfo-textGray-vuVJc {
	color: rgb(77, 65, 51) !important;
}

.VerifiedInfo-listStyle-Mb22B {
	padding-left: 0;
	list-style: none;
	font-size: 14px;
	line-height: 1.43;
	margin: 0px;
}

.VerifiedInfo-titleText-wh0vF {
	font-size: 16px;
	margin: 0px 0px 12px;
	line-height: 20px;
	font-weight: 600;
}

.VerifiedInfo-displayGrid-AP4YM {
	display: grid;
	grid-template-columns: 20px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 10px;
	padding-bottom: 10px;
	color: var(--secondary-foreground);
}

.VerifiedInfo-noPaddingBottom-rsEdc {
	padding-bottom: 0px;
}

.VerifiedInfo-marginIfonText-QBKoU {
	margin: 10px 0px 7px 0px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.VerifiedInfo-moreVerifi-JxwI7 {
	display: inline-block;
	font-size: 16px;
	line-height: 20px;
}

.VerifiedInfo-moreVerifi-JxwI7,
.VerifiedInfo-moreVerifi-JxwI7:hover,
.VerifiedInfo-moreVerifi-JxwI7:active,
.VerifiedInfo-moreVerifi-JxwI7:focus {
	color: var(--primary-link-foreground);
}

.VerifiedInfo-moreVerifiArrow-HtrNm {
	margin-left: 4px;
	position: relative;
	top: -1px;
}

.VerifiedInfo-textCenter-UDvha {
	text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/VerifiedInfo/VerifiedInfo.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,oBAAoB;CACpB,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;CAIC,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.listStyle {\n\tpadding-left: 0;\n\tlist-style: none;\n\tfont-size: 14px;\n\tline-height: 1.43;\n\tmargin: 0px;\n}\n\n.titleText {\n\tfont-size: 16px;\n\tmargin: 0px 0px 12px;\n\tline-height: 20px;\n\tfont-weight: 600;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 20px auto;\n\talign-items: center;\n\tgrid-gap: 10px;\n\tpadding-bottom: 10px;\n\tcolor: var(--secondary-foreground);\n}\n\n.noPaddingBottom {\n\tpadding-bottom: 0px;\n}\n\n.marginIfonText {\n\tmargin: 10px 0px 7px 0px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.moreVerifi {\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tline-height: 20px;\n}\n\n.moreVerifi,\n.moreVerifi:hover,\n.moreVerifi:active,\n.moreVerifi:focus {\n\tcolor: var(--primary-link-foreground);\n}\n\n.moreVerifiArrow {\n\tmargin-left: 4px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.textCenter {\n\ttext-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `VerifiedInfo-space1-ig6mI`,
	"space2": `VerifiedInfo-space2-i7Nri`,
	"space3": `VerifiedInfo-space3-XYHnO`,
	"space4": `VerifiedInfo-space4-gGb9r`,
	"space5": `VerifiedInfo-space5-Fi_kd`,
	"space6": `VerifiedInfo-space6-X8Zts`,
	"space7": `VerifiedInfo-space7-yD4NC`,
	"spaceTop8": `VerifiedInfo-spaceTop8-qTxCF`,
	"spaceTop1": `VerifiedInfo-spaceTop1-v7fIh`,
	"spaceTop2": `VerifiedInfo-spaceTop2-_qaVf`,
	"spaceTop3": `VerifiedInfo-spaceTop3-ZbVmK`,
	"spaceTop4": `VerifiedInfo-spaceTop4-QagfS`,
	"spaceTop5": `VerifiedInfo-spaceTop5-KdkL7`,
	"spaceTop6": `VerifiedInfo-spaceTop6-etvUJ`,
	"spaceTop7": `VerifiedInfo-spaceTop7-hWZ48`,
	"noMargin": `VerifiedInfo-noMargin-AbSkJ`,
	"padding1": `VerifiedInfo-padding1-W5tEV`,
	"padding2": `VerifiedInfo-padding2-NpPgo`,
	"padding3": `VerifiedInfo-padding3-TyqIM`,
	"padding4": `VerifiedInfo-padding4-yHmBf`,
	"padding5": `VerifiedInfo-padding5-FM1Js`,
	"padding6": `VerifiedInfo-padding6-xQJOt`,
	"padding7": `VerifiedInfo-padding7-OBujS`,
	"paddingTop1": `VerifiedInfo-paddingTop1-ox6fO`,
	"paddingTop2": `VerifiedInfo-paddingTop2-rj78r`,
	"paddingTop3": `VerifiedInfo-paddingTop3-LlDO1`,
	"paddingTop4": `VerifiedInfo-paddingTop4-OlErE`,
	"paddingTop5": `VerifiedInfo-paddingTop5-eJnMJ`,
	"paddingTop6": `VerifiedInfo-paddingTop6-u2tVv`,
	"paddingTop7": `VerifiedInfo-paddingTop7-TzxrY`,
	"noPadding": `VerifiedInfo-noPadding-Rari6`,
	"textBold": `VerifiedInfo-textBold-hjETe`,
	"textBolder": `VerifiedInfo-textBolder-qVTAb`,
	"textNormal": `VerifiedInfo-textNormal-Dz64R`,
	"spaceBottom20": `VerifiedInfo-spaceBottom20-bWbH6`,
	"spaceBottom10": `VerifiedInfo-spaceBottom10-OaiSH`,
	"marginNone": `VerifiedInfo-marginNone-_aWDP`,
	"spaceBottom15": `VerifiedInfo-spaceBottom15-PRpwb`,
	"marginTopNone": `VerifiedInfo-marginTopNone-JjfK0`,
	"spaceTop11": `VerifiedInfo-spaceTop11-mIkav`,
	"spaceTop21": `VerifiedInfo-spaceTop21-spQ3P`,
	"spaceTop20": `VerifiedInfo-spaceTop20-YsY_M`,
	"spaceTop10": `VerifiedInfo-spaceTop10-Ac8wk`,
	"textDarkBlue": `VerifiedInfo-textDarkBlue-C1Zh4`,
	"textLightBlue": `VerifiedInfo-textLightBlue-cch8y`,
	"textLightSandleGreen": `VerifiedInfo-textLightSandleGreen-s52N2`,
	"textLightBrown": `VerifiedInfo-textLightBrown-kk1Fh`,
	"textMediumMaroon": `VerifiedInfo-textMediumMaroon-WMhwR`,
	"textBrown": `VerifiedInfo-textBrown-XgeBC`,
	"textMaroon": `VerifiedInfo-textMaroon-wdJB4`,
	"textDarkBrown": `VerifiedInfo-textDarkBrown-PPTK7`,
	"textMediumBrown": `VerifiedInfo-textMediumBrown-srJzC`,
	"textSkyBlue": `VerifiedInfo-textSkyBlue-Ai_5V`,
	"textGray": `VerifiedInfo-textGray-vuVJc`,
	"listStyle": `VerifiedInfo-listStyle-Mb22B`,
	"titleText": `VerifiedInfo-titleText-wh0vF`,
	"displayGrid": `VerifiedInfo-displayGrid-AP4YM`,
	"noPaddingBottom": `VerifiedInfo-noPaddingBottom-rsEdc`,
	"marginIfonText": `VerifiedInfo-marginIfonText-QBKoU`,
	"moreVerifi": `VerifiedInfo-moreVerifi-JxwI7`,
	"moreVerifiArrow": `VerifiedInfo-moreVerifiArrow-HtrNm`,
	"textCenter": `VerifiedInfo-textCenter-UDvha`
};
module.exports = ___CSS_LOADER_EXPORT___;
